module.exports = __webpack_public_path__ + "img/6.baa8d058.svg";